var WebPageManager = {
    init: function() {
        WebPageManager.industryDropdownSelect = '.industry-dropdown select';
        WebPageManager.onChangeInitSelectIndustry();
        WebPageManager.applySlideshowOnCustomerReviews();
    },

    onChangeInitSelectIndustry: function() {
        if($(WebPageManager.industryDropdownSelect) && $(WebPageManager.industryDropdownSelect).length > 0) {
            var pathName = window.location.pathname;
            var industryDropdownValue = $(WebPageManager.industryDropdownSelect + " option").val();
            if(pathName !== industryDropdownValue) {
                $(WebPageManager.industryDropdownSelect + " option[value='" + pathName + "']").prop('selected', true);
            }
        }

        $(WebPageManager.industryDropdownSelect).on('change', function() {
            var industrySelected = $(this).val();
            window.location = industrySelected;
        });
    },

    applySlideshowOnCustomerReviews: function() {
        var customerReviews = ".customers-review-slider";

        if(customerReviews && customerReviews.length > 0) {
            $(customerReviews).slick({
                infinite: false,
                dots: true,
                appendDots: "#customers-review-navDots",
                prevArrow: "#customers-review-navPrev",
                nextArrow: "#customers-review-navNext",
                slidesToShow: 1,
                slidesToScroll: 1
            });
        }
    }
}

$(document).ready(function() {
    WebPageManager.init();
});
